// import React, { useState, useEffect } from 'react';
// import Papa from 'papaparse';
// import { 
//   ChevronUp, 
//   ChevronDown, 
//   Filter, 
//   Download, 
//   Eye, 
//   MoreVertical,
//   Calendar,
//   AlertTriangle,
//   CheckCircle,
//   Ship  // Added missing import
// } from 'lucide-react';
// import { Menu, Transition } from '@headlessui/react';

// const ShipMaintenanceTable = () => {
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [filter, setFilter] = useState('default');
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [searchTerm, setSearchTerm] = useState('');

//   useEffect(() => {
//     // Load CSV data
//     const fetchData = async () => {
//       try {
//         const response = await fetch('/predictions.csv');
//         const csvText = await response.text();
        
//         Papa.parse(csvText, {
//           header: true,
//           skipEmptyLines: true,
//           complete: (results) => {
//             const parsedData = results.data.map((row, index) => ({
//               id: index + 1,
//               imoNo: row['IMO NO'] || '',
//               vesselName: (row['VESSEL NAME'] || '').toUpperCase(),
//               nextMaintenanceDate: new Date(row['NEXT MAINTENANCE DATE'] || Date.now()),
//               maintenanceType: ['Dry Dock', 'Routine', 'Engine', 'Hull'][Math.floor(Math.random() * 4)],
//               priority: ['High', 'Medium', 'Low'][Math.floor(Math.random() * 3)],
//               estimatedCost: Math.floor(Math.random() * 100000) + 50000,
//               status: ['Scheduled', 'In Progress', 'Pending', 'Completed'][Math.floor(Math.random() * 4)]
//             }));
            
//             setData(parsedData);
//             setFilteredData(parsedData);
//           }
//         });
//       } catch (error) {
//         console.error('Error loading CSV:', error);
//         // Fallback sample data
//         const sampleData = generateSampleData();
//         setData(sampleData);
//         setFilteredData(sampleData);
//       }
//     };

//     fetchData();
//   }, []);

//   const generateSampleData = () => {
//     const vessels = [
//       'MV OCEAN KING', 'MV SEA PEARL', 'MV BLUE WAVE', 'MV STAR VOYAGER',
//       'MV GOLDEN HORIZON', 'MV SILVER BREEZE', 'MV PACIFIC RIDER', 'MV ATLANTIC QUEEN'
//     ];
//     return Array.from({ length: 20 }, (_, i) => ({
//       id: i + 1,
//       imoNo: `IMO${9000000 + i}`,
//       vesselName: vessels[Math.floor(Math.random() * vessels.length)],
//       nextMaintenanceDate: new Date(Date.now() + Math.random() * 90 * 24 * 60 * 60 * 1000),
//       maintenanceType: ['Dry Dock', 'Routine', 'Engine', 'Hull'][Math.floor(Math.random() * 4)],
//       priority: ['High', 'Medium', 'Low'][Math.floor(Math.random() * 3)],
//       estimatedCost: Math.floor(Math.random() * 100000) + 50000,
//       status: ['Scheduled', 'In Progress', 'Pending', 'Completed'][Math.floor(Math.random() * 4)]
//     }));
//   };

//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
    
//     const sortedData = [...filteredData].sort((a, b) => {
//       if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
//       if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
//       return 0;
//     });
    
//     setSortConfig({ key, direction });
//     setFilteredData(sortedData);
//   };

//   const handleFilterChange = (value) => {
//     setFilter(value);
//     let filtered = [...data];
    
//     if (value === 'upcoming-week') {
//       const now = new Date();
//       const nextWeek = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
//       filtered = data.filter(item => item.nextMaintenanceDate >= now && item.nextMaintenanceDate <= nextWeek);
//     } else if (value === 'upcoming-month') {
//       const now = new Date();
//       const nextMonth = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
//       filtered = data.filter(item => item.nextMaintenanceDate >= now && item.nextMaintenanceDate <= nextMonth);
//     } else if (value === 'high-priority') {
//       filtered = data.filter(item => item.priority === 'High');
//     }
    
//     if (searchTerm) {
//       filtered = filtered.filter(item =>
//         item.vesselName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.imoNo.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     setFilteredData(filtered);
//   };

//   const handleSearch = (term) => {
//     setSearchTerm(term);
//     let filtered = [...data];
    
//     if (term) {
//       filtered = data.filter(item =>
//         item.vesselName.toLowerCase().includes(term.toLowerCase()) ||
//         item.imoNo.toLowerCase().includes(term.toLowerCase())
//       );
//     }
    
//     if (filter !== 'default') {
//       handleFilterChange(filter);
//     } else {
//       setFilteredData(filtered);
//     }
//   };

//   const formatDate = (date) => {
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const getStatusColor = (status) => {
//     switch(status) {
//       case 'Completed': return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300';
//       case 'In Progress': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
//       case 'Scheduled': return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300';
//       default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
//     }
//   };

//   const getPriorityIcon = (priority) => {
//     switch(priority) {
//       case 'High': return <AlertTriangle className="text-red-500" size={16} />;
//       case 'Medium': return <AlertTriangle className="text-amber-500" size={16} />;
//       default: return <AlertTriangle className="text-emerald-500" size={16} />;
//     }
//   };

//   return (
//     <div className="overflow-x-auto">
//       <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center justify-between space-y-4 sm:space-y-0">
//         <div className="flex-1">
//           <div className="relative max-w-xs">
//             <input
//               type="text"
//               placeholder="Search vessels..."
//               value={searchTerm}
//               onChange={(e) => handleSearch(e.target.value)}
//               className="pl-10 pr-4 py-2 w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <div className="absolute left-3 top-2.5 text-gray-400">
//               <Eye size={18} />
//             </div>
//           </div>
//         </div>
        
//         <div className="flex items-center space-x-3">
//           <select
//             value={filter}
//             onChange={(e) => handleFilterChange(e.target.value)}
//             className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             <option value="default">All Maintenance</option>
//             <option value="upcoming-week">Upcoming Week</option>
//             <option value="upcoming-month">Upcoming Month</option>
//             <option value="high-priority">High Priority</option>
//           </select>
          
//           <button className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center space-x-2">
//             <Download size={18} />
//             <span>Export</span>
//           </button>
//         </div>
//       </div>
      
//       <table className="w-full">
//         <thead className="bg-gray-50 dark:bg-gray-800">
//           <tr>
//             {[
//               { key: 'imoNo', label: 'IMO NO' },
//               { key: 'vesselName', label: 'VESSEL NAME' },
//               { key: 'nextMaintenanceDate', label: 'NEXT MAINTENANCE' },
//               { key: 'maintenanceType', label: 'TYPE' },
//               { key: 'priority', label: 'PRIORITY' },
//               { key: 'estimatedCost', label: 'ESTIMATED COST' },
//               { key: 'status', label: 'STATUS' },
//               { key: 'actions', label: 'ACTIONS' }
//             ].map((column) => (
//               <th
//                 key={column.key}
//                 className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
//                 onClick={() => column.key !== 'actions' && handleSort(column.key)}
//               >
//                 <div className="flex items-center space-x-1">
//                   <span>{column.label}</span>
//                   {sortConfig.key === column.key && (
//                     sortConfig.direction === 'asc' ? 
//                     <ChevronUp size={16} /> : 
//                     <ChevronDown size={16} />
//                   )}
//                 </div>
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
//           {filteredData.map((row) => (
//             <tr key={row.id} className="hover:bg-gray-50 dark:hover:bg-gray-800/50">
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <div className="text-sm font-medium text-gray-900 dark:text-white">
//                   {row.imoNo}
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <div className="flex items-center">
//                   <div className="w-8 h-8 rounded-md bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mr-3">
//                     <Ship size={16} className="text-blue-600 dark:text-blue-400" />
//                   </div>
//                   <div>
//                     <div className="text-sm font-medium text-gray-900 dark:text-white">
//                       {row.vesselName}
//                     </div>
//                     <div className="text-sm text-gray-500 dark:text-gray-400">
//                       IMO: {row.imoNo}
//                     </div>
//                   </div>
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <div className="flex items-center">
//                   <Calendar className="mr-2 text-gray-400" size={16} />
//                   <div>
//                     <div className="text-sm font-medium text-gray-900 dark:text-white">
//                       {formatDate(row.nextMaintenanceDate)}
//                     </div>
//                     <div className="text-sm text-gray-500 dark:text-gray-400">
//                       in {Math.ceil((row.nextMaintenanceDate - new Date()) / (1000 * 60 * 60 * 24))} days
//                     </div>
//                   </div>
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
//                   {row.maintenanceType}
//                 </span>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <div className="flex items-center">
//                   {getPriorityIcon(row.priority)}
//                   <span className="ml-2 text-sm font-medium">{row.priority}</span>
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <div className="text-sm font-medium text-gray-900 dark:text-white">
//                   ${row.estimatedCost.toLocaleString()}
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <span className={`px-3 py-1 text-xs rounded-full ${getStatusColor(row.status)}`}>
//                   {row.status}
//                 </span>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap">
//                 <Menu as="div" className="relative">
//                   <Menu.Button className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded">
//                     <MoreVertical size={20} className="text-gray-400" />
//                   </Menu.Button>
//                   <Transition
//                     enter="transition ease-out duration-100"
//                     enterFrom="transform opacity-0 scale-95"
//                     enterTo="transform opacity-100 scale-100"
//                     leave="transition ease-in duration-75"
//                     leaveFrom="transform opacity-100 scale-100"
//                     leaveTo="transform opacity-0 scale-95"
//                   >
//                     <Menu.Items className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-10">
//                       <div className="py-1">
//                         <Menu.Item>
//                           {({ active }) => (
//                             <button className={`${
//                               active ? 'bg-gray-100 dark:bg-gray-700' : ''
//                             } flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}>
//                               <Eye className="mr-2" size={16} />
//                               View Details
//                             </button>
//                           )}
//                         </Menu.Item>
//                         <Menu.Item>
//                           {({ active }) => (
//                             <button className={`${
//                               active ? 'bg-gray-100 dark:bg-gray-700' : ''
//                             } flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}>
//                               <Calendar className="mr-2" size={16} />
//                               Reschedule
//                             </button>
//                           )}
//                         </Menu.Item>
//                       </div>
//                     </Menu.Items>
//                   </Transition>
//                 </Menu>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
      
//       {filteredData.length === 0 && (
//         <div className="text-center py-12">
//           <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
//             <Filter className="text-gray-400" size={24} />
//           </div>
//           <p className="text-gray-500 dark:text-gray-400">No maintenance records found</p>
//           <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">Try adjusting your filters or search term</p>
//         </div>
//       )}
      
//       <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
//         <div className="text-sm text-gray-500 dark:text-gray-400">
//           Showing <span className="font-medium">{filteredData.length}</span> of <span className="font-medium">{data.length}</span> records
//         </div>
//         <div className="flex items-center space-x-2">
//           <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
//             Previous
//           </button>
//           <button className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700">
//             1
//           </button>
//           <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
//             2
//           </button>
//           <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ShipMaintenanceTable;

import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { 
  ChevronUp, 
  ChevronDown, 
  Filter, 
  Download, 
  Eye, 
  MoreVertical,
  Calendar,
  AlertTriangle,
  Ship
} from 'lucide-react';
import { Menu, Transition } from '@headlessui/react';

const ShipMaintenanceTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState('default');
  const [sortConfig, setSortConfig] = useState({ 
    key: 'nextMaintenanceDate', 
    direction: 'asc' // ascending means nearest upcoming dates first
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    // Load CSV data
    const fetchData = async () => {
      try {
        const response = await fetch('/predictions.csv');
        const csvText = await response.text();
        
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsedData = results.data.map((row, index) => ({
              id: index + 1,
              imoNo: row['IMO NO'] || '',
              vesselName: (row['VESSEL NAME'] || '').toUpperCase(),
              nextMaintenanceDate: new Date(row['NEXT MAINTENANCE DATE'] || Date.now()),
              maintenanceType: ['Dry Dock', 'Routine', 'Engine', 'Hull'][Math.floor(Math.random() * 4)],
              priority: ['High', 'Medium', 'Low'][Math.floor(Math.random() * 3)],
              estimatedCost: Math.floor(Math.random() * 100000) + 50000,
              status: ['Scheduled', 'In Progress', 'Pending', 'Completed'][Math.floor(Math.random() * 4)],
              isUpcoming: true // We'll calculate this after parsing
            }));
            
            // First, separate upcoming and past maintenance
            const now = new Date();
            const upcomingMaintenance = parsedData.filter(item => 
              item.nextMaintenanceDate >= now
            ).sort((a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate);
            
            const pastMaintenance = parsedData.filter(item => 
              item.nextMaintenanceDate < now
            ).sort((a, b) => b.nextMaintenanceDate - a.nextMaintenanceDate); // Most recent past first
            
            // Combine: upcoming first, then past
            const sortedData = [...upcomingMaintenance, ...pastMaintenance];
            
            setData(sortedData);
            setFilteredData(sortedData);
          }
        });
      } catch (error) {
        console.error('Error loading CSV:', error);
        // Fallback sample data
        const sampleData = generateSampleData();
        const sortedSampleData = sortDataWithUpcomingFirst(sampleData);
        setData(sortedSampleData);
        setFilteredData(sortedSampleData);
      }
    };

    fetchData();
  }, []);

  // Function to sort data with upcoming first, then past
  const sortDataWithUpcomingFirst = (dataArray) => {
    const now = new Date();
    const upcoming = dataArray.filter(item => item.nextMaintenanceDate >= now)
      .sort((a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate); // Nearest upcoming first
    
    const past = dataArray.filter(item => item.nextMaintenanceDate < now)
      .sort((a, b) => b.nextMaintenanceDate - a.nextMaintenanceDate); // Most recent past first
    
    return [...upcoming, ...past];
  };

  const generateSampleData = () => {
    const vessels = [
      'MV OCEAN KING', 'MV SEA PEARL', 'MV BLUE WAVE', 'MV STAR VOYAGER',
      'MV GOLDEN HORIZON', 'MV SILVER BREEZE', 'MV PACIFIC RIDER', 'MV ATLANTIC QUEEN'
    ];
    return Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      imoNo: `IMO${9000000 + i}`,
      vesselName: vessels[Math.floor(Math.random() * vessels.length)],
      // Generate dates from past 30 days to future 90 days
      nextMaintenanceDate: new Date(Date.now() + (Math.random() * 120 - 30) * 24 * 60 * 60 * 1000),
      maintenanceType: ['Dry Dock', 'Routine', 'Engine', 'Hull'][Math.floor(Math.random() * 4)],
      priority: ['High', 'Medium', 'Low'][Math.floor(Math.random() * 3)],
      estimatedCost: Math.floor(Math.random() * 100000) + 50000,
      status: ['Scheduled', 'In Progress', 'Pending', 'Completed'][Math.floor(Math.random() * 4)]
    }));
  };

  const handleSort = (key) => {
    let direction = 'asc';
    
    // If clicking on the same column, toggle direction
    if (sortConfig.key === key) {
      direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
    } else {
      // For date column, default to upcoming first logic
      if (key === 'nextMaintenanceDate') {
        direction = 'asc'; // Upcoming first by default
      }
    }
    
    const sortedData = [...filteredData].sort((a, b) => {
      if (key === 'nextMaintenanceDate') {
        // Special sorting for dates: upcoming first, then past
        const now = new Date();
        const aIsUpcoming = a.nextMaintenanceDate >= now;
        const bIsUpcoming = b.nextMaintenanceDate >= now;
        
        // If one is upcoming and the other is past, upcoming comes first
        if (aIsUpcoming && !bIsUpcoming) return -1;
        if (!aIsUpcoming && bIsUpcoming) return 1;
        
        // Both are upcoming or both are past
        const dateA = a[key].getTime();
        const dateB = b[key].getTime();
        
        if (aIsUpcoming) {
          // Both upcoming: sort ascending (nearest first)
          return direction === 'asc' ? dateA - dateB : dateB - dateA;
        } else {
          // Both past: sort descending (most recent first)
          return direction === 'asc' ? dateB - dateA : dateA - dateB;
        }
      }
      
      // For other fields
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    
    setSortConfig({ key, direction });
    setFilteredData(sortedData);
  };

  const handleFilterChange = (value) => {
    setFilter(value);
    let filtered = [...data];
    
    if (value === 'upcoming-week') {
      const now = new Date();
      const nextWeek = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      filtered = data.filter(item => 
        item.nextMaintenanceDate >= now && 
        item.nextMaintenanceDate <= nextWeek
      ).sort((a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate);
    } else if (value === 'upcoming-month') {
      const now = new Date();
      const nextMonth = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
      filtered = data.filter(item => 
        item.nextMaintenanceDate >= now && 
        item.nextMaintenanceDate <= nextMonth
      ).sort((a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate);
    } else if (value === 'high-priority') {
      filtered = data.filter(item => item.priority === 'High');
      filtered = sortDataWithUpcomingFirst(filtered);
    } else if (value === 'upcoming-only') {
      const now = new Date();
      filtered = data.filter(item => item.nextMaintenanceDate >= now)
        .sort((a, b) => a.nextMaintenanceDate - b.nextMaintenanceDate);
    } else if (value === 'past-only') {
      const now = new Date();
      filtered = data.filter(item => item.nextMaintenanceDate < now)
        .sort((a, b) => b.nextMaintenanceDate - a.nextMaintenanceDate);
    }
    
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.vesselName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.imoNo.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    setFilteredData(filtered);
    // Reset sort to date with upcoming first logic
    setSortConfig({ key: 'nextMaintenanceDate', direction: 'asc' });
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    let filtered = [...data];
    
    if (term) {
      filtered = data.filter(item =>
        item.vesselName.toLowerCase().includes(term.toLowerCase()) ||
        item.imoNo.toLowerCase().includes(term.toLowerCase())
      );
    }
    
    if (filter !== 'default') {
      handleFilterChange(filter);
    } else {
      // Sort with upcoming first logic
      const sortedFiltered = sortDataWithUpcomingFirst(filtered);
      setFilteredData(sortedFiltered);
      setSortConfig({ key: 'nextMaintenanceDate', direction: 'asc' });
    }
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getDaysDifference = (date) => {
    const now = new Date();
    const diffTime = date - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays === -1) return 'Yesterday';
    if (diffDays < 0) return `${Math.abs(diffDays)} days ago`;
    return `in ${diffDays} days`;
  };

  const isUpcoming = (date) => {
    return date >= new Date();
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'Completed': return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300';
      case 'In Progress': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
      case 'Scheduled': return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300';
      default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
    }
  };

  const getPriorityIcon = (priority) => {
    switch(priority) {
      case 'High': return <AlertTriangle className="text-red-500" size={16} />;
      case 'Medium': return <AlertTriangle className="text-amber-500" size={16} />;
      default: return <AlertTriangle className="text-emerald-500" size={16} />;
    }
  };

  const getDateIndicator = (date) => {
    const now = new Date();
    if (date >= now) {
      return (
        <div className="flex items-center mt-1">
          <div className="w-2 h-2 rounded-full bg-green-500 mr-2"></div>
          <span className="text-xs text-green-600 dark:text-green-400">Upcoming</span>
        </div>
      );
    } else {
      return (
        <div className="flex items-center mt-1">
          <div className="w-2 h-2 rounded-full bg-red-500 mr-2"></div>
          <span className="text-xs text-red-600 dark:text-red-400">Past Due</span>
        </div>
      );
    }
  };

  return (
    <div className="overflow-hidden flex flex-col h-[600px]">
      {/* Header Section */}
      <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center justify-between space-y-4 sm:space-y-0">
        <div className="flex-1">
          <div className="relative max-w-xs">
            <input
              type="text"
              placeholder="Search vessels..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              className="pl-10 pr-4 py-2 w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="absolute left-3 top-2.5 text-gray-400">
              <Eye size={18} />
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <select
            value={filter}
            onChange={(e) => handleFilterChange(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="default">All Maintenance</option>
            <option value="upcoming-only">Upcoming Only</option>
            <option value="upcoming-week">Upcoming Week</option>
            <option value="upcoming-month">Upcoming Month</option>
            <option value="past-only">Past Due</option>
            <option value="high-priority">High Priority</option>
          </select>
          
          <button className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center space-x-2">
            <Download size={18} />
            <span>Export</span>
          </button>
        </div>
      </div>
      
      {/* Table Container with Fixed Height and Scroll */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800 sticky top-0 z-10">
              <tr>
                {[
                  { key: 'imoNo', label: 'IMO NO' },
                  { key: 'vesselName', label: 'VESSEL NAME' },
                  { key: 'nextMaintenanceDate', label: 'NEXT MAINTENANCE' },
                  { key: 'maintenanceType', label: 'TYPE' },
                  { key: 'priority', label: 'PRIORITY' },
                  { key: 'estimatedCost', label: 'ESTIMATED COST' },
                  { key: 'status', label: 'STATUS' },
                  { key: 'actions', label: 'ACTIONS' }
                ].map((column) => (
                  <th
                    key={column.key}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
                    onClick={() => column.key !== 'actions' && handleSort(column.key)}
                  >
                    <div className="flex items-center space-x-1">
                      <span>{column.label}</span>
                      {column.key !== 'actions' && (
                        sortConfig.key === column.key ? (
                          sortConfig.direction === 'asc' ? 
                          <ChevronUp size={16} /> : 
                          <ChevronDown size={16} />
                        ) : (
                          <ChevronUp size={16} className="opacity-30" />
                        )
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {filteredData.map((row) => (
                <tr 
                  key={row.id} 
                  className={`hover:bg-gray-50 dark:hover:bg-gray-800/50 ${
                    !isUpcoming(row.nextMaintenanceDate) ? 'bg-red-50/30 dark:bg-red-900/10' : ''
                  }`}
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                      {row.imoNo}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className={`w-8 h-8 rounded-md flex items-center justify-center mr-3 ${
                        isUpcoming(row.nextMaintenanceDate) 
                          ? 'bg-blue-100 dark:bg-blue-900/30' 
                          : 'bg-red-100 dark:bg-red-900/30'
                      }`}>
                        <Ship 
                          size={16} 
                          className={
                            isUpcoming(row.nextMaintenanceDate) 
                              ? 'text-blue-600 dark:text-blue-400' 
                              : 'text-red-600 dark:text-red-400'
                          } 
                        />
                      </div>
                      <div>
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {row.vesselName}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400">
                          IMO: {row.imoNo}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Calendar className={`mr-2 ${
                        isUpcoming(row.nextMaintenanceDate) 
                          ? 'text-gray-400' 
                          : 'text-red-400'
                      }`} size={16} />
                      <div>
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {formatDate(row.nextMaintenanceDate)}
                        </div>
                        <div className={`text-sm font-medium ${
                          isUpcoming(row.nextMaintenanceDate) 
                            ? 'text-green-600 dark:text-green-400' 
                            : 'text-red-600 dark:text-red-400'
                        }`}>
                          {getDaysDifference(row.nextMaintenanceDate)}
                        </div>
                        {getDateIndicator(row.nextMaintenanceDate)}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                      {row.maintenanceType}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      {getPriorityIcon(row.priority)}
                      <span className="ml-2 text-sm font-medium">{row.priority}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                      ${row.estimatedCost.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 text-xs rounded-full ${getStatusColor(row.status)}`}>
                      {row.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <Menu as="div" className="relative">
                      <Menu.Button className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded">
                        <MoreVertical size={20} className="text-gray-400" />
                      </Menu.Button>
                      <Transition
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-20">
                          <div className="py-1">
                            <Menu.Item>
                              {({ active }) => (
                                <button className={`${
                                  active ? 'bg-gray-100 dark:bg-gray-700' : ''
                                } flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}>
                                  <Eye className="mr-2" size={16} />
                                  View Details
                                </button>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <button className={`${
                                  active ? 'bg-gray-100 dark:bg-gray-700' : ''
                                } flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300`}>
                                  <Calendar className="mr-2" size={16} />
                                  Reschedule
                                </button>
                              )}
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {filteredData.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
                <Filter className="text-gray-400" size={24} />
              </div>
              <p className="text-gray-500 dark:text-gray-400">No maintenance records found</p>
              <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">Try adjusting your filters or search term</p>
            </div>
          )}
        </div>
      </div>
      
      {/* Footer with Pagination */}
      <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between bg-white dark:bg-gray-900">
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Showing <span className="font-medium">{filteredData.length}</span> of <span className="font-medium">{data.length}</span> records
          <span className="ml-4">
            {filteredData.filter(item => isUpcoming(item.nextMaintenanceDate)).length} upcoming, 
            {' '}{filteredData.filter(item => !isUpcoming(item.nextMaintenanceDate)).length} past due
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
            Previous
          </button>
          <button className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700">
            1
          </button>
          <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
            2
          </button>
          <button className="px-3 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShipMaintenanceTable;